import { format } from 'date-fns'

export default {
  methods: {
    getThumbnail(value) {
      const filename = value.split('/').pop()
      return `https://cfheeal1sl.execute-api.eu-west-1.amazonaws.com/dev/800x800/${filename}`
    },
    formatDateTime(value) {
      return format(new Date(value), 'dd MMM yyyy HH:mm')
    },
    formatTime(ticks) {
      let milliseconds = Math.abs(parseInt(ticks % 1000, 10))
      let seconds = parseInt((ticks / 1000) % 60, 10)
      let minutes = parseInt((ticks / (1000 * 60)) % 60, 10)
      let hours = parseInt((ticks / (1000 * 60 * 60)) % 60, 10)

      hours = hours.toString().padStart(2, '0')
      minutes = minutes.toString().padStart(2, '0')
      seconds = seconds.toString().padStart(2, '0')
      milliseconds = milliseconds.toString().padStart(3, '0')

      return `${hours}:${minutes}:${seconds}.${milliseconds}`
    }
  }
}
